import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export interface ClosableModalProps {
  onRequestClose?: (buttonClicked: boolean) => void;
  open?: boolean;
  title: string;
  dialogMessageVariable?: string | number;
  actions?: ReactNode[];
  children?: ReactNode;
}

const ClosableModal: React.FC<ClosableModalProps> = ({
  open = false,
  onRequestClose,
  title,
  dialogMessageVariable,
  actions,
  children,
}) => {
  const intl = useIntl();

  const translatedTitle = intl.messages[title]
    ? intl.formatMessage(
        { id: title },
        { variable: dialogMessageVariable ?? '' }
      )
    : title;

  return (
    <Dialog
      className="closable-modal-radius"
      open={open}
      keepMounted
      onClose={() => onRequestClose?.(false)}
    >
      <DialogTitle>{translatedTitle}</DialogTitle>
      <DialogContent>
        <div>{children}</div>
      </DialogContent>
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
};

export default ClosableModal;
